module.exports = __webpack_public_path__ + "ba3e22b8e595fec568231b833680e376.pdf";